import committee from './view';
import judge from '../judge/view';

export default [
  {
    path: '/',
    component: committee('/redirect'),
  },
  {
    path: 'login', // 로그인
    component: committee('/login'),
  },
  {
    path: 'join', // 인증위원회 가입
    component: committee('/join'),
  },
  {
    path: 'userInfo', // 인증위원회 개인정보관리
    component: committee('/userInfo'),
  },
  {
    path: 'joinComplete', // 인증심사원 가입 완료
    component: committee('/joinComplete'),
  },
  {
    path: 'list', // 인증위원회 목록
    component: committee('/list'),
  },
  {
    path: 'review/:sq', // 인증심의상세보기
    component: committee('/review'),
  },
  {
    path: 'result/:sq', // 인증심의상세보기
    component: committee('/result'),
  },


  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/committee/index.js